import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import HorizontalSplitOutlinedIcon from '@mui/icons-material/HorizontalSplitOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from '@ui/theme';
import React from 'react';

import useStyles from './StagingIncludes.style';

const MovingIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#D3E0E2', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <LocalShippingOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const PackingIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#EDC687', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <WidgetsOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const OrganizingIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#E8E5F2', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <Inventory2OutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const DeclutteringIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#FFCAB3', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <HorizontalSplitOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const JunkIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#DDD4C7', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <DeleteOutlinedIcon sx={{ fontSize: 30, strokeWidth: 20 }} />
    </Box>
  );
};

const stagingIncludes = [
  {
    icon: MovingIconWrapper,
    caption: 'Moving'
  },
  {
    icon: PackingIconWrapper,
    caption: 'Packing'
  },
  {
    icon: DeclutteringIconWrapper,
    caption: 'Decluttering'
  },
  {
    icon: OrganizingIconWrapper,
    caption: 'Organizing'
  },
  {
    icon: JunkIconWrapper,
    caption: 'Junk Removal'
  },
];

const StagingIncludes: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: theme.spacing(2)
      }}
    >
      {stagingIncludes.map((si, i) => {
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              flex: '0 0 calc(35% - 20px)',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className={classes.root}
          >
            <si.icon />
            <Typography className={classes.caption}>
              {si.caption}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default StagingIncludes;
